<template>
  <div
    class="school-id-auth-field max-w-[360px] m-auto mt-8 pt-8 relative h-[118px]"
  >
    <input
      v-model.trim="scId"
      class="shadow appearance-none border rounded w-full py-3 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"
      :class="{ 'border-red-500': !!errMsg }"
      id="scId"
      placeholder="Enter your school id"
      maxlength="7"
    />
    <p v-if="!!errMsg" class="text-red-500 text-xs italic">
      {{ errMsg }}
    </p>
  </div>
</template>

<script>
import { getCookie } from "@/helpers/utils";

export default {
  props: ["currentStep"],
  data() {
    const defaultSchoolId = getCookie("schoolId") || "";
    return {
      scId: defaultSchoolId
    };
  },
  computed: {
    errMsg() {
      return this.currentStep.error;
    }
  },
  watch: {
    scId: function(val) {
      this.$emit("can-continue", { value: !!val });
      this.$set(this.currentStep, "scId", this.scId);

      this.currentStep.error && this.$set(this.currentStep, "error", "");
    }
  },
  mounted() {
    this.$set(this.currentStep, "scId", this.scId);
    this.$emit("can-continue", { value: !!this.scId });
    if (this.scId) {
      this.nextStep();
    }
  },
  inject: ["nextStep"]
};
</script>

<style lang="scss" scoped></style>
